import {useEffect} from "react";
import {setChosenLanguage} from "../slices/globalParamsSlice";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";

export const useLanguageRefresh = () => {
    const {t, i18n} = useTranslation();
    const dispatch = useDispatch();
    const {chosenLanguage} = useSelector(state => state.globalParams.globalParams);

    useEffect(() => {
        if (!chosenLanguage?.value) {
            const lang = i18n.resolvedLanguage || i18n.language;
            dispatch(setChosenLanguage({value: lang, label: t(lang), collapsedLabel: t(`${lang}Short`)}));
        }
    }, [dispatch, i18n.resolvedLanguage, i18n.language, chosenLanguage?.value, t]);

    useEffect(() => {
        const lang = chosenLanguage?.value;
        if (!lang) return;

        dispatch(setChosenLanguage({
            value: lang,
            label: t(lang),
            collapsedLabel: t(`${lang}Short`)
        }));
        i18n.changeLanguage(lang);
    }, [i18n.language, chosenLanguage?.value, dispatch]);

    return null;
}